<script setup>
import { OneBoxDefault } from '@weathernews/btos-vuecomponent/with-onebox-common-elements/src'

const props = defineProps({
  breadCrumbList: {
    type: Array,
    default: () => []
  }
})
const { $ads } = useNuxtApp()
const runtimeConfig = useRuntimeConfig()
const EnvDevDomains = runtimeConfig.public.devDomains
const devDomains = EnvDevDomains ? JSON.parse(EnvDevDomains) : null
useCustomJsonld(props.breadCrumbList)
onMounted(() => {
  $ads.init(adsConfig)
})
</script>

<template>
  <div>
    <OneBoxDefault
      :bread-crumb-list="breadCrumbList"
      :dev-domains="devDomains"
    >
      <slot />
      <template #main-bottom>
        <slot name="main-bottom" />
      </template>
      <template #ads-btf3>
        <div
          id="ads-btf3"
          class="ads-btf3"
        />
      </template>
    </OneBoxDefault>
    <StickyAd />
  </div>
</template>

<style>
html {
  scroll-behavior: unset;
}
</style>

<style scoped>
.ads-atf-pc {
  min-height: 50px;
  margin: 0px auto 10px;
  text-align: center;
  position: relative;
}
.ads-atf-sp {
  min-height: 50px;
  margin: 0px auto 10px;
  text-align: center;
  position: relative;
}
.ads-btf3 {
  min-height: 50px;
  margin: 15px auto 5px;
}
</style>
